import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Container, Row, Col } from 'react-bootstrap';
import { FaXTwitter } from 'react-icons/fa6';
import { FaFacebook } from 'react-icons/fa';




function FooterBottom() {
  return (
    <>
      {/*----------------------------------footer-Top part----------------------------------*/}
      <div className="">
        <Container>
          <div className="">
            <div className="marquee">
              <div className="marquee-content">
                <a href="https://pgportal.gov.in/" target="_blank" rel="noopener noreferrer">
                  <img src="images/cp-grams.png" alt="Forest Department" />
                  {/* <ImageComponent imagepath={"Assets/1733180578425_cp-grams.png"} typePhoto={"forest"} /> */}
                </a>
                <a href="https://www.data.gov.in/" target="_blank" rel="noopener noreferrer">
                  <img src="images/data.png" alt="Fisheries Department" />
                  {/* <ImageComponent imagepath={"Assets/1733180655199_data.png"} typePhoto={"fishers"} /> */}
                </a>
                <a href="https://www.digitalindia.gov.in/" target="_blank" rel="noopener noreferrer">
                  <img src="images/digiindia.png" alt="Industries Department" />
                  {/* <ImageComponent imagepath={"Assets/1733180697895_digiindia.png"} typePhoto={"industries"} /> */}
                </a>
                <a href="https://egazette.gov.in/" target="_blank" rel="noopener noreferrer">
                  <img src="images/egaze.png" alt="Agriculture Department" />
                  {/* <ImageComponent imagepath={"Assets/1733180732320_egaze.png"} typePhoto={"agriculture"} /> */}
                </a>
                <a href="https://www.india.gov.in/ " target="_blank" rel="noopener noreferrer">
                  <img src="images/india-gov.png" alt="Agriculture Department" />
                  {/* <ImageComponent imagepath={"Assets/1733180772205_india-gov.png"} typePhoto={"noopener"} /> */}
                </a>
                <a href="https://egazette.gov.in/" target="_blank" rel="noopener noreferrer">
                  <img src="images/egaze.png" alt="Agriculture Department" />
                  {/* <ImageComponent imagepath={"Assets/1733180732320_egaze.png"} typePhoto={"agriculture"} /> */}
                </a>
                <a
                  href="https://zeropovertyp4.ap.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="images/p42-img2.png"
                    alt="Zero Poverty P4"
                    className="p4-slider-img"
                  />
                </a>
                <a href="https://pgportal.gov.in/" target="_blank" rel="noopener noreferrer">
                  <img src="images/cp-grams.png" alt="Forest Department" />
                  {/* <ImageComponent imagepath={"Assets/1733180578425_cp-grams.png"} typePhoto={"forest"} /> */}
                </a>
                <a href="https://www.data.gov.in/" target="_blank" rel="noopener noreferrer">
                  <img src="images/data.png" alt="Fisheries Department" />
                  {/* <ImageComponent imagepath={"Assets/1733180655199_data.png"} typePhoto={"fishers"} /> */}
                </a>
                <a href="https://www.digitalindia.gov.in/" target="_blank" rel="noopener noreferrer">
                  <img src="images/digiindia.png" alt="Industries Department" />
                  {/* <ImageComponent imagepath={"Assets/1733180697895_digiindia.png"} typePhoto={"industries"} /> */}
                </a>
                <a href="https://egazette.gov.in/" target="_blank" rel="noopener noreferrer">
                  <img src="images/egaze.png" alt="Agriculture Department" />
                  {/* <ImageComponent imagepath={"Assets/1733180732320_egaze.png"} typePhoto={"agriculture"} /> */}
                </a>
                <a href="https://www.india.gov.in/ " target="_blank" rel="noopener noreferrer">
                  <img src="images/india-gov.png" alt="Agriculture Department" />
                  {/* <ImageComponent imagepath={"Assets/1733180772205_india-gov.png"} typePhoto={"noopener"} /> */}
                </a>
                <a href="https://egazette.gov.in/" target="_blank" rel="noopener noreferrer">
                  <img src="images/egaze.png" alt="Agriculture Department" />
                  {/* <ImageComponent imagepath={"Assets/1733180732320_egaze.png"} typePhoto={"agriculture"} /> */}
                </a>
                <a
                  href="https://zeropovertyp4.ap.gov.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="images/p42-img2.png"
                    alt="Zero Poverty P4"
                    className="p4-slider-img"
                  />
                </a>
              </div>
            </div>


          </div>
        </Container>
      </div>
      {/*----------------------------middle-part-----------------------------------------*/}
      <div className='footer-section pt-5' id='footer-section'>
        <Container fluid>
          <footer >
            <Container>
              <Row>
                <Col xxl={1} xl={1} lg={1} md={0} sm={0} xs={0}></Col>
                <Col xxl={2} xl={2} lg={2} md={3} sm={6} xs={6}>
                  <div className="footer-col">
                    <h3>Related Links</h3>
                    <ul className='ulist '>
                      <li> <a href="#" rel="noopener noreferrer">ap.gov.in</a></li>
                      <li><a href="#" rel="noopener noreferrer">apfinance.gov.in</a></li>
                      <li><a href="#" rel="noopener noreferrer">cfms.ap.gov.in</a></li>
                      <li><a href="#" rel="noopener noreferrer">dwa.ap.gov.in</a></li>
                      <li><a href="#" rel="noopener noreferrer">dsa.ap.gov.in</a></li>
                      <li><a href="#" rel="noopener noreferrer">treasury.ap.gov.in</a></li>
                    </ul>
                  </div>
                </Col>
                <Col xxl={2} xl={2} lg={2} md={3} sm={6} xs={6}>
                  <div className="footer-col">
                    <h3>Policies</h3>
                    <ul className='ulist'>
                      <li><a href="/CopyRight" rel="noopener noreferrer">Copyright Policy</a></li>
                      <li><a href="/PrivacyPolicy" rel="noopener noreferrer">Privacy Policy</a></li>
                      <li><a href="/HyperLink" rel="noopener noreferrer">Hyperlinking Policy</a></li>
                      <li><a href="/TermsUse" rel="noopener noreferrer">Terms of Use</a></li>
                    </ul>
                  </div>
                </Col>
                <Col xxl={2} xl={2} lg={2} md={3} sm={6} xs={6}>
                  <div className="footer-col">
                    <ul className='ulist uilist-marg'>
                      <li><a href="/AboutUs" >About Us</a></li>
                      <li><a href="/ContactPage" >Contact Us</a></li>
                      <li><a href="/Feedback" >Feedback</a></li>
                      <li><a href="/Faq">FAQs</a></li>
                      <li><a href="/Helpsection" >Help</a></li>
                    </ul>
                  </div>
                </Col>
                <Col xxl={2} xl={2} lg={2} md={3} sm={6} xs={6}>
                  <div className="footer-col">

                    <ul className='ulist uilist-marg'>
                      <li><a href="/Sitemap" >Site Map</a></li>
                      <li><a href="/Website" >Website Policy</a></li>
                      <li><a href="/Disclaimer" rel="noopener noreferrer">Disclaimer</a></li>
                    </ul>
                  </div>
                </Col>
                <Col xxl={2} xl={2} lg={2} md={3} sm={6} xs={6}>
                  <div className="footer-col ">
                    <h3>Follow Us</h3>

                    <div className="social-links">
                      <a href="#" target="_blank">
                        <div className="facebook">
                          <FaFacebook className='link-icon' />
                        </div>
                      </a>
                      <a href="#" target="_blank">
                        <div className="facebook">
                          <FaXTwitter className='link-icon' />
                        </div>
                      </a>
                    </div>
                  </div>
                </Col>
                <Col xxl={1} xl={1} lg={1} md={0} sm={0} xs={0}></Col>
              </Row>
              <div className='right-part-footer'>

                <p>All information, data, and materials published on this portal are owned and approved by the Director, Swarnandhra 2047. The Director is responsible for ensuring the accuracy, authenticity, and timely updating of the content displayed on this website.</p>
              </div>
            </Container>
          </footer>
        </Container>
      </div>
      {/*---------------------------------------bottom-footer---------------------------------------*/}
      <div className="container-fluid bottom-footer">
        <div className="bottom-footer-inner-container">
          <div className="bootom-footer-content">
            <Row>
              <Col xxl={2} xl={3} lg={4} md={4} sm={12} xs={12}>
                <div class="left-part-footer">
                  <h4>Translation Disclaimer</h4>
                </div>
              </Col>
              <Col xxl={10} xl={9} lg={8} md={8} sm={12} xs={12}>
                <div className="right-part-footer">
                  <p>This website has been translated into multiple languages for the convenience of users. While every effort has been made to ensure the accuracy, correctness, and reliability of the translated content, the English version (or original language version) shall prevail in case of any variation or discrepancy. The translated content is provided through automated/assisted translation tools, and therefore may not be fully accurate or reflect the intended meaning of the original text.
                    The Department / Organisation does not accept any responsibility for errors or omissions that may occur due to translation. Users are advised to refer to the original version of the website for official and legally valid information. If any inconsistency is observed, kindly report it to the website administrator for corrective action.</p>
                </div>
              </Col>
            </Row>
          </div>

        </div>
      </div>
      <div className="container-fluid brand-bottom-footer">
        <div class="brand-bottom-inner-footer">
          <div>
            <p className="footer-p1">
              Copyright © 2025 Swarnandhra  All Rights Reserved
            </p>
          </div>
          <div >
            <p className="footer-p2">
              Last reviewed and updated on 22 July 2025 at 4:55:15pm
            </p>
          </div>
          <div className="text1">
            <p className="footer-p3">Designed and developed by</p>
            <a href="#" >
              <img src="../images/apcfss-logo-white.svg"
                className="footer-image img-fluid footer-brand-logo"
              />
            </a>
          </div>
        </div>
      </div>
    </>

  );
}

export default FooterBottom;